import React, { useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import api from '../../api/client';
import AnteprimaDocumento from '../../components/AnteprimaDocumento';

// Portale: le ricevute dei corsi della persona collegata all'account, una per ciclo.
// Si possono scaricare anche prima del saldo: il PDF esce con la scritta NON PAGATA.
const euro = (n) => `€ ${(n || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function LeMieRicevute() {
  const [elenco, setElenco] = useState(null);
  const [aperta, setAperta] = useState(null);
  const carica = () => api.get('/ricevute/me').then(r => setElenco(r.data)).catch(() => setElenco([]));
  useEffect(() => { carica(); }, []);

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <h1 style={s.title}>Le mie ricevute</h1>
        <p style={s.sub}>Le ricevute dei corsi a cui sei iscritto, una per ciclo. Finché il corso non è saldato la ricevuta riporta "NON PAGATA".</p>
      </div>
      {elenco === null && <div style={s.sub}>Caricamento…</div>}
      {elenco?.length === 0 && (
        <div style={s.card}>
          <div style={{ fontWeight: 600 }}>Nessuna ricevuta disponibile</div>
          <div style={{ ...s.sub, marginTop: 4 }}>Compaiono qui quando sei in un gruppo di un corso avviato con un pacchetto o una quota da pagare. Se pensi che manchi qualcosa scrivi all'associazione.</div>
        </div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {(elenco || []).map(r => (
          <div key={r.ciclo_id} style={{ ...s.card, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontWeight: 700 }}>{r.ciclo}</div>
              <div style={s.sub}>Stagione {r.stagione}{r.numero ? ` · ricevuta n. ${r.numero}` : ''}</div>
              <div style={{ fontSize: 'var(--font-size-sm)', marginTop: 4 }}>
                Totale <b>{euro(r.totale)}</b> · pagato {euro(r.pagato)}
                {r.pagata
                  ? <span style={{ ...s.badge, background: '#22C55E20', color: '#15803D' }}>PAGATA</span>
                  : <span style={{ ...s.badge, background: '#EF444418', color: '#B91C1C' }}>DA SALDARE {euro(r.residuo)}</span>}
              </div>
            </div>
            <button style={s.btn} onClick={() => setAperta({ ...r, definitiva: false })}><FileText size={14} /> {r.numero ? 'APRI' : 'VEDI'} RICEVUTA</button>
          </div>
        ))}
      </div>
      {aperta && (
        <AnteprimaDocumento doc={{ nome: `Ricevuta ${aperta.ciclo}`, file_nome: 'ricevuta.pdf', tipo: 'Ricevuta' }}
          endpoint={aperta.numero || aperta.definitiva ? `/ricevute/me/${aperta.ciclo_id}/pdf` : `/ricevute/me/${aperta.ciclo_id}/anteprima`}
          avviso={aperta.numero || aperta.definitiva ? null : 'Anteprima: controlla i dati e premi "Conferma e genera" per avere la ricevuta con il suo numero.'}
          azioni={aperta.numero || aperta.definitiva ? null : <button style={{ ...s.btn, padding: '7px 12px' }} onClick={() => setAperta(a => ({ ...a, definitiva: true }))}>CONFERMA E GENERA</button>}
          onClose={() => { setAperta(null); carica(); }} />
      )}
    </div>
  );
}

const s = {
  title: { fontFamily: "'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight: '800', letterSpacing: '2px' },
  sub: { color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)', marginTop: '2px' },
  card: { background: 'var(--bg-card)', borderRadius: 'var(--radius-card, 14px)', padding: '14px 16px', boxShadow: 'var(--shadow-card)' },
  badge: { marginLeft: 8, fontSize: 'var(--font-size-xs)', fontWeight: 700, padding: '2px 8px', borderRadius: 999 },
  btn: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '9px 14px', borderRadius: 999, border: 0, background: '#C24B08', color: '#fff', fontWeight: 700, fontSize: 'var(--font-size-xs)', cursor: 'pointer' },
};
